import React from "react";
import {
  Box,
  Button,
  Heading,
  Loader,
  Text,
  TextButton,
} from "@wix/design-system";
import { MobileBottomSheet } from "../MobileBottomSheet/MobileBottomSheet";
import { X } from "@wix/wix-ui-icons-common";
import { TEXT_STANDARD_PRIMARY_COLOR } from "@wix/picasso-common";

interface RecreateBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  formContent: React.ReactNode;
  primaryButtonText: string;
  secondaryButtonText: string;
  isGenerating: boolean;
  handleGenerateSite: () => void;
  handleCancel: () => void;
}

export const RecreateBottomSheet = ({
  isOpen,
  title,
  subtitle,
  formContent,
  primaryButtonText,
  secondaryButtonText,
  isGenerating,
  handleGenerateSite,
  handleCancel,
  onClose,
}: RecreateBottomSheetProps) => {
  return (
    <MobileBottomSheet
      open={isOpen}
      onClose={handleCancel}
      shouldBlockView
      fitContent
    >
      <Box direction="vertical" padding="0 16px 12px 16px">
        <Box align="space-between" verticalAlign="top" marginBottom={2}>
          <Box direction="vertical" gap={1}>
            <Heading size="medium">{title}</Heading>
            <Text size="small" secondary>
              {subtitle}
            </Text>
          </Box>
          <TextButton
            size="small"
            onClick={onClose}
            prefixIcon={<X color={TEXT_STANDARD_PRIMARY_COLOR} />}
          />
        </Box>
        {formContent}
        <Box gap={2} marginTop={2}>
          <Button
            fullWidth
            skin="dark"
            priority="secondary"
            onClick={handleCancel}
            disabled={isGenerating}
          >
            {secondaryButtonText}
          </Button>
          <Button
            fullWidth
            onClick={handleGenerateSite}
            disabled={isGenerating}
          >
            {isGenerating ? <Loader size="tiny" /> : primaryButtonText}
          </Button>
        </Box>
      </Box>
    </MobileBottomSheet>
  );
};
